import { render, staticRenderFns } from "./right_fin.vue?vue&type=template&id=132a8887&scoped=true&"
import script from "./right_fin.vue?vue&type=script&lang=js&"
export * from "./right_fin.vue?vue&type=script&lang=js&"
import style0 from "./right_fin.vue?vue&type=style&index=0&id=132a8887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a8887",
  null
  
)

export default component.exports